console.log('login.js file loaded');

$(document).on('turbolinks:load', function() {
    console.log('Turbolinks load event fired in login.js');
    $('.admin-login-name-field').on('input',function(){
        let text = $(this).val();
        console.log('Input changed:', text);
        if(text == 'max'){
          $('.login-button').html("<button type='submit' class='admin-login-button-font'>ログイン</button>")
        }else {
          $('.login-button').html("")
        }
    });
});

// 初回読み込み時にも実行
$(document).ready(function() {
    console.log('Document ready in login.js');
    $('.admin-login-name-field').on('input',function(){
        let text = $(this).val();
        if(text == 'max'){
          $('.login-button').html("<button type='submit' class='admin-login-button-font'>ログイン</button>")
        }else {
          $('.login-button').html("")
        }
    });
});


  